module.exports = {"id":"212722","name":"DeAndre Yedlin","rating":"75","photo":"./data/images/photos/4/212722.png","club":{"name":"Newcastle Utd","logo":"./data/images/clubs/NewcastleUtd.png"},"positions":["DD"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DeAndreYedlin0.json
// module id = 1027
// module chunks = 0